/**
 * Web Component pour alterner entre deux textes
 * 
 * @example
 * <alternate-text data-interval="3000">
 *   <div>Texte principal</div>
 *   <div>Texte alternatif</div>
 * </alternate-text>
 */
class AlternateText extends HTMLElement {
  #intervalId = null;
  #currentIndex = 0;
  #texts = [];
  #interval = 3000;

  connectedCallback() {
    this.#init();
  }

  disconnectedCallback() {
    this.#cleanup();
  }

  #init() {
    // Récupérer l'intervalle depuis les data attributes
    const intervalAttr = this.dataset.interval;
    if (intervalAttr) {
      this.#interval = parseInt(intervalAttr, 10);
    }

    // Récupérer les deux textes enfants
    const children = Array.from(this.children);
    if (children.length < 2) {
      console.warn('AlternateText: Au moins 2 éléments enfants sont requis');
      return;
    }

    // Stocker le contenu HTML des textes
    this.#texts = children.map(child => child.innerHTML);

    // Masquer tous les enfants sauf le premier
    children.forEach((child, index) => {
      child.style.display = index === 0 ? 'block' : 'none';
    });

    // Démarrer l'alternance
    this.#startAlternating();
  }

  #startAlternating() {
    this.#intervalId = setInterval(() => {
      this.#switchText();
    }, this.#interval);
  }

  #switchText() {
    const children = Array.from(this.children);
    if (children.length < 2) return;

    // Masquer le texte actuel
    children[this.#currentIndex].style.display = 'none';

    // Passer au texte suivant
    this.#currentIndex = (this.#currentIndex + 1) % children.length;

    // Afficher le nouveau texte
    children[this.#currentIndex].style.display = 'block';
  }

  #cleanup() {
    if (this.#intervalId) {
      clearInterval(this.#intervalId);
      this.#intervalId = null;
    }
  }
}

customElements.define('alternate-text', AlternateText);

